<template>
<svg class="icon__report-flag"
width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.34 25.34"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M12.67 21.59a1.19 1.19 0 0 1-.85-.35 1.22 1.22 0 0 1 0-1.71 1.21 1.21 0 0 1 1.7 0 1.2 1.2 0 0 1 0 1.71 1.19 1.19 0 0 1-.85.35zM13.83 4l-.25 13.73a.28.28 0 0 1-.27.26H12a.28.28 0 0 1-.28-.26L11.46 4a.22.22 0 0 1 .22-.22h1.93a.22.22 0 0 1 .22.22z"/><path class="cls-1" d="M12.67 2A10.67 10.67 0 1 1 2 12.67 10.67 10.67 0 0 1 12.67 2m0-2a12.67 12.67 0 1 0 12.67 12.67A12.68 12.68 0 0 0 12.67 0z"/></g></g></svg>
</template>

<script>
export default {
    name: "IconReport"
};
</script>


<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__report-flag {
	fill: $sony-white;
	path {
		transition: all 0.3s ease;
	}
}
</style>
